import { fromLatLng } from './location';
import { locationAddressFromGeocode } from './user-location';

export const locationFromLatLng = async (lat, lng) => {
    if (lat != null && lng != null) {
        try {
            const [geocode] = await fromLatLng(lat, lng);
            return await locationAddressFromGeocode(geocode, lat, lng);
        } catch (e) {
            console.warn(e);
        }
    }
};
